export default __webpack_public_path__ + "dist/media/Added-to-project.723fece0.svg";